export default "__VITE_ASSET__13073590__"